import { React } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, CheckboxField, RadioGroupField, Radio, Flex, Text, TextField, TextAreaField, SelectField, View } from '@aws-amplify/ui-react';
import { typedReturnValue, handleInteger, handleIntegerBlur } from "../anamnese_lib/validateInteger";
import YesNo from "../anamnese_lib/YesNo";

const VegetativeAnamnese = (props) => {
    const daten = useSelector(state => state.anamnese.Daten);
    const dispatch = useDispatch();

    const handleChange = (e) => {
        // console.log(e)
        const key = e.target.name;
        const val = typedReturnValue(key, e.target.value);
        dispatch({ type: 'anamnese/Modify', payload: { [key]: val } });
        props.handleChange(e);
    }

    const handleCheck = (e) => {
        const key = e.target.name;
        const val = e.target.value === 'on' ? 1 : 0;
        dispatch({ type: 'anamnese/Modify', payload: { [key]: val } });
        props.handleChange(e);
    }

    const handleDate = (e) => {
        const name = e.currentTarget.name;
        const value = e.currentTarget.value;
        handleChange({ target: { name, value } });
    }

    // console.log(daten)

    return (
        <>
            <h4>1.5	Vegetative Anamnese</h4>
            <h5>Appetit</h5>
            <RadioGroupField
                value={daten.APPETIT}
                onChange={handleChange}
                descriptiveText=""
                name="APPETIT"
                alignItems="center"
                direction="row">
                {['normal', 'schlecht', 'gut', 'sehr gut'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.APPETIT !== i ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            <p></p>
            <h5>Ernährung</h5>
            <h6>Haben Sie Einschränkungen oder Unverträglichkeiten bei der Ernährung?</h6>
            <YesNo name="UNVERTRAEGLICHKEITEN_YN" value={daten.UNVERTRAEGLICHKEITEN_YN} onChange={handleChange} readOnly={props.readOnly} />
            {daten.UNVERTRAEGLICHKEITEN_YN === 1 &&
                <TextAreaField
                    name="UNVERTRAEGLICHKEITEN"
                    width="100%"
                    defaultValue={daten.UNVERTRAEGLICHKEITEN}
                    onChange={handleChange}
                    descriptiveText="Welche?"
                    wrap="nowrap"
                    maxLength={256}
                    rows={2}
                    readOnly={props.readOnly}
                />
            }
            <p></p>
            <h6>Denken Sie, dass Sie sich gesund und ausgewogen ernähren?</h6>
            <RadioGroupField
                value={daten.AUSGEW_ERNAEHRUNG}
                onChange={handleChange}
                descriptiveText=""
                name="AUSGEW_ERNAEHRUNG"
                alignItems="center"
                direction="row">
                {['ja, auf jeden Fall', 'meistens gelingt es'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.AUSGEW_ERNAEHRUNG !== i ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            <RadioGroupField
                value={daten.AUSGEW_ERNAEHRUNG}
                onChange={handleChange}
                descriptiveText=""
                name="AUSGEW_ERNAEHRUNG"
                alignItems="center"
                direction="row">
                {['manchmal, aber es fällt schwer', 'eher nicht'].map((item, i) => <Radio key={`RG_${i + 2}`} value={i + 2} disabled={daten.AUSGEW_ERNAEHRUNG !== (i + 2) ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            <p></p>
            <h5>Verdauung</h5>
            <h6>Leiden Sie unter den folgenden Magen-Darm-Beschwerden?</h6>
            <Flex
                direction="row"
                gap={'1.5rem'}
            >
                <CheckboxField
                    name="UEBELKEIT"
                    value={daten.UEBELKEIT === 1 ? "off" : "on"}
                    checked={daten.UEBELKEIT === 1}
                    onChange={handleCheck}
                    label="Übelkeit"
                    disabled={props.readOnly}
                />
                <CheckboxField
                    name="ERBRECHEN"
                    value={daten.ERBRECHEN === 1 ? "off" : "on"}
                    checked={daten.ERBRECHEN === 1}
                    onChange={handleCheck}
                    label="Erbrechen"
                    disabled={props.readOnly}
                />
                <CheckboxField
                    name="SODBRENNEN"
                    value={daten.SODBRENNEN === 1 ? "off" : "on"}
                    checked={daten.SODBRENNEN === 1}
                    onChange={handleCheck}
                    label="Sodbrennen"
                    disabled={props.readOnly}
                />
            </Flex>
            <Flex
                direction="row"
                gap={'1.5rem'}
            >
                <CheckboxField
                    name="BLAEHUNGEN"
                    value={daten.BLAEHUNGEN === 1 ? "off" : "on"}
                    checked={daten.BLAEHUNGEN === 1}
                    onChange={handleCheck}
                    label="Blähungen"
                    disabled={props.readOnly}
                />
                <CheckboxField
                    name="BAUCHSCHMERZEN"
                    value={daten.BAUCHSCHMERZEN === 1 ? "off" : "on"}
                    checked={daten.BAUCHSCHMERZEN === 1}
                    onChange={handleCheck}
                    label="Bauchschmerzen"
                    disabled={props.readOnly}
                />
            </Flex>
            <p></p>
            <h6>Stuhlgang</h6>
            <RadioGroupField
                value={daten.STUHLGANG}
                onChange={handleChange}
                descriptiveText=""
                name="STUHLGANG"
                direction="row">
                {['normal', 'Verstopfung', 'Durchfall'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.STUHLGANG !== i ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            {daten.STUHLGANG === 2 &&

                <TextField
                    name="DURCHFALL"
                    defaultValue={daten.DURCHFALL}
                    hasError={props.hasError.DURCHFALL}
                    errorMessage="Der Wert muß zwischen 1 und 10 liegen."
                    onChange={e => handleInteger(e, handleChange, 1, 10, props.hasError, props.setHasError)}
                    onBlur={e => handleIntegerBlur(e, 1, 10, props.hasError, props.setHasError)}
                    direction="row"
                    label="wie oft am Tag?"
                    alignItems="center"
                    readOnly={props.readOnly}
                />
            }
            Ist Blut im Stuhl?
            <YesNo name="STUHLGANG_BLUT_YN" value={daten.STUHLGANG_BLUT_YN} onChange={handleChange} readOnly={props.readOnly} />
            <p></p>
            <h5>Größe und Gewicht</h5>
            <TextField
                label="Größe"
                name="GROESSE"
                minWidth="4rem"
                defaultValue={parseInt(daten.GROESSE)}
                hasError={props.hasError.GROESSE}
                errorMessage="Der Wert muß zwischen 100 und 230 liegen."
                onChange={(e) => handleInteger(e, handleChange, 100, 230, props.hasError, props.setHasError)}
                onBlur={e => handleIntegerBlur(e, 100, 230, props.hasError, props.setHasError)}
                direction="row"
                alignItems="center"
                readOnly={props.readOnly}
                outerEndComponent={<Button>cm</Button>}
            />
            <p></p>
            <TextField
                label="Gewicht aktuell"
                name="GEWICHT_AKT"
                minWidth="4rem"
                defaultValue={parseInt(daten.GEWICHT_AKT)}
                hasError={props.hasError.GEWICHT_AKT}
                errorMessage="Der Wert muß zwischen 40 und 250 liegen."
                onChange={(e) => handleInteger(e, handleChange, 40, 250, props.hasError, props.setHasError)}
                onBlur={e => handleIntegerBlur(e, 40, 250, props.hasError, props.setHasError)}
                direction="row"
                alignItems="center"
                readOnly={props.readOnly}
                outerEndComponent={<Button>kg</Button>}
            />
            {daten.GEWICHT_AKT > 150 && <p>Bei mehr als 150 kg aktuellem Gewicht, melden Sie sich bitte <b>vor</b> Antritt der Massnahme telefonisch bei unserem Aufnahmebüro.</p>}
            <p></p>
            <TextField
                label="Gewicht vor 1 Jahr"
                name="GEWICHT_VOR1J"
                minWidth="4rem"
                defaultValue={parseInt(daten.GEWICHT_VOR1J)}
                hasError={props.hasError.GEWICHT_VOR1J}
                errorMessage="Der Wert muß zwischen 40 und 250 liegen."
                onChange={(e) => handleInteger(e, handleChange, 40, 250, props.hasError, props.setHasError)}
                onBlur={e => handleIntegerBlur(e, 40, 250, props.hasError, props.setHasError)}
                direction="row"
                alignItems="center"
                readOnly={props.readOnly}
                outerEndComponent={<Button>kg</Button>}
            />
            <p></p>
            <Text>bei Gewichtsveränderung:</Text>
            <RadioGroupField
                value={daten.GEWVERAENDERUNG}
                onChange={handleChange}
                descriptiveText=""
                name="GEWVERAENDERUNG"
                direction="row">
                {['unbeabsichtigt', 'absichtlich'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.GEWVERAENDERUNG !== i ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            <TextField
                label="Bemerkungen:"
                name="GEW_BEMERKUNG"
                width="100%"
                defaultValue={daten.GEW_BEMERKUNG}
                onChange={handleChange}
                maxLength={256}
                readOnly={props.readOnly}
            />
            <p></p>
            <h5>Wasserlassen</h5>
            <Flex
                direction="row"
                gap={'1.5rem'}
            >
                Haben Sie Beschwerden beim Wasserlassen?
                <YesNo name="WASSERLASSEN_YN" value={daten.WASSERLASSEN_YN} onChange={handleChange} readOnly={props.readOnly} />
            </Flex>
            <Flex
                direction="row"
                gap={'1.5rem'}
            >
                {daten.WASSERLASSEN_YN === 1 &&
                    <TextField
                        name="WASSERLASSEN"
                        width="100%"
                        defaultValue={daten.WASSERLASSEN}
                        onChange={handleChange}
                        descriptiveText="Welche?"
                        wrap="nowrap"
                        maxLength={80}
                        readOnly={props.readOnly}
                    />
                }
            </Flex>
            <p></p>
            <Flex
                direction="row"
                gap={'1.5rem'}
                alignItems='center'
            >
                nächtlicher Harndrang?
                <YesNo name="HARNDRANG_YN" value={daten.HARNDRANG_YN} onChange={handleChange} readOnly={props.readOnly} />
                {daten.HARNDRANG_YN === 1 &&
                    <>
                        <TextField
                            name="HARNDRANG_ANZ"
                            width="10%"
                            defaultValue={daten.HARNDRANG_ANZ}
                            hasError={props.hasError.HARNDRANG_ANZ}
                            errorMessage="Der Wert muß zwischen 0 und 10 liegen."
                            onChange={(e) => handleInteger(e, handleChange, 0, 10, props.hasError, props.setHasError)}
                            onBlur={e => handleIntegerBlur(e, 0, 10, props.hasError, props.setHasError)}
                            readOnly={props.readOnly}
                        />
                        <View>mal pro Nacht</View>
                    </>
                }
            </Flex>
            <p></p>
            <Flex
                direction="row"
                gap={'1.5rem'}
            >
                <View width="10rem">geschwollene Beine?</View>
                <RadioGroupField
                    value={daten.GESCHW_BEINE}
                    onChange={handleChange}
                    descriptiveText=""
                    name="GESCHW_BEINE"
                    alignItems="center"
                    direction="row">
                    {['nein', 'nur abends', 'immer'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.GESCHW_BEINE !== i ? props.readOnly : false}>{item}</Radio>)}
                </RadioGroupField>
            </Flex>
            <p></p>
            <h5>Atemwege</h5>
            <Text>Haben Sie Atemnot?</Text>
            <RadioGroupField
                value={daten.ATEMNOT}
                onChange={handleChange}
                descriptiveText=""
                name="ATEMNOT"
                alignItems="center"
                direction="row">
                {['nein', 'selten', 'beim Treppensteigen'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.ATEMNOT !== i ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            <RadioGroupField
                value={daten.ATEMNOT}
                onChange={handleChange}
                descriptiveText=""
                name="ATEMNOT"
                alignItems="center"
                direction="row">
                {['anfallsweise', 'nachts'].map((item, i) => <Radio key={`RG_${i + 3}`} value={i + 3} disabled={daten.ATEMNOT !== (i + 3) ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            <Text>Haben Sie Husten?</Text>
            <RadioGroupField
                value={daten.HUSTEN}
                onChange={handleChange}
                descriptiveText=""
                name="HUSTEN"
                alignItems="center"
                direction="row">
                {['nein', 'täglich', 'mehr als 3 Monate im Jahr'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.HUSTEN !== i ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            <Text>Haben Sie Auswurf?</Text>
            <RadioGroupField
                value={daten.AUSWURF}
                onChange={handleChange}
                descriptiveText=""
                name="AUSWURF"
                direction="row">
                {['nein', 'klar', 'grau-weiß', 'gelb-eitrig'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.AUSWURF !== i ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            <p></p>
            <h5>Schlaf</h5>
            <RadioGroupField
                value={daten.SCHLAF}
                onChange={handleChange}
                descriptiveText=""
                name="SCHLAF"
                direction="row">
                {['gut', 'Einschlafstörungen'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.SCHLAF !== i ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            <RadioGroupField
                value={daten.SCHLAF}
                onChange={handleChange}
                descriptiveText=""
                name="SCHLAF"
                direction="row">
                {['Durchschlafstörungen'].map((item, i) => <Radio key={`RG_${i + 2}`} value={i + 2} disabled={daten.SCHLAF !== (i + 2) ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            <RadioGroupField
                value={daten.SCHLAF}
                onChange={handleChange}
                descriptiveText=""
                name="SCHLAF"
                direction="row">
                {['frühmorgendliches Erwachen'].map((item, i) => <Radio key={`RG_${i + 3}`} value={i + 3} disabled={daten.SCHLAF !== (i + 3) ? props.readOnly : false}>{item}</Radio>)}
            </RadioGroupField>
            <Flex direction='row' style={{ marginLeft: '0.5rem' }}>
                <CheckboxField
                    name="SCHLAFSTOERUNG_S"
                    value={daten.SCHLAFSTOERUNG_S === 1 ? "off" : "on"}
                    checked={daten.SCHLAFSTOERUNG_S === 1}
                    onChange={handleCheck}
                    label="wegen Schmerzen"
                    disabled={props.readOnly}
                />
                <CheckboxField
                    name="SCHLAFSTOERUNG_G"
                    value={daten.SCHLAFSTOERUNG_G === 1 ? "off" : "on"}
                    checked={daten.SCHLAFSTOERUNG_G === 1}
                    onChange={handleCheck}
                    label="wegen Grübelns"
                    disabled={props.readOnly}
                />
            </Flex>
            <Flex direction='row' style={{ marginLeft: '0.5rem' }}>
                <CheckboxField
                    name="SCHLAFMITTEL"
                    value={daten.SCHLAFMITTEL === 1 ? "off" : "on"}
                    checked={daten.SCHLAFMITTEL === 1}
                    onChange={handleCheck}
                    label="Schlafmitteleinnahme"
                    disabled={props.readOnly}
                />
            </Flex>
            <p></p>
            <h5>Allergien</h5>
            <Flex
                direction="row"
                gap={'1.5rem'}
            >
                Haben Sie Allergien?
                <YesNo name="ALLERGIEN_YN" value={daten.ALLERGIEN_YN} onChange={handleChange} readOnly={props.readOnly} />
            </Flex>
            <p></p>
            {daten.ALLERGIEN_YN === 1 &&
                <TextAreaField
                    name="ALLERGIEN"
                    width="100%"
                    defaultValue={daten.ALLERGIEN}
                    onChange={handleChange}
                    descriptiveText="Welche?"
                    wrap="nowrap"
                    maxLength={256}
                    rows={2}
                    readOnly={props.readOnly}
                />
            }
            <p></p>
            <h5>Genussmittelanamnese</h5>
            <h6>Nikotin:</h6>
            <Flex
                direction="row"
                gap={'2rem'}
                alignItems='center'
            >
                <RadioGroupField
                    value={daten.NIKOTIN}
                    onChange={handleChange}
                    descriptiveText=""
                    alignItems="center"
                    name="NIKOTIN"
                    direction="row">
                    {['nie', 'gelegentlich', 'nicht mehr', 'täglich'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.NIKOTIN !== i ? props.readOnly : false}>{item}</Radio>)}
                </RadioGroupField>
            </Flex>
            {daten.NIKOTIN === 2 &&
                <TextField
                    alignItems='center'
                    name="KEINNIKOTIN_SEIT"
                    label={'seit: '}
                    defaultValue={daten.KEINNIKOTIN_SEIT}
                    width="40%"
                    placeholder="Jahreszahl?"
                    onChange={handleDate}
                    direction="row"
                    maxLength={20}
                    readOnly={props.readOnly}
                />
            }
            {daten.NIKOTIN === 3 &&
                <>
                    <p></p>
                    <Flex
                        direction="row"
                        gap={'2rem'}
                        alignItems='center'
                    >

                        <TextField
                            alignItems='center'
                            name="NIKOTIN_TAEGL"
                            label={'etwa: '}
                            defaultValue={daten.NIKOTIN_TAEGL}
                            hasError={props.hasError.NIKOTIN_TAEGL}
                            errorMessage="Der Wert muß zwischen 0 und 100 liegen."
                            onChange={(e) => handleInteger(e, handleChange, 0, 100, props.hasError, props.setHasError)}
                            onBlur={e => handleIntegerBlur(e, 0, 100, props.hasError, props.setHasError)}
                            direction="row"
                            readOnly={props.readOnly}
                        />
                        <SelectField
                            value={daten.NIKOTINTYP}
                            onChange={handleChange}
                            name="NIKOTINTYP"
                            direction="row"
                            disabled={props.readOnly}
                        >
                            <option value="0">-- bitte auswählen --</option>
                            <option value="1">Zigaretten</option>
                            <option value="2">Zigarren</option>
                            <option value="3">Pfeifen</option>
                        </SelectField>
                    </Flex>
                    <p></p>
                    <Flex
                        direction="row"
                        gap={'2rem'}
                        alignItems='center'
                    >
                        <TextField
                            alignItems='center'
                            name="NIKOTIN_SEIT"
                            label={'seit '}
                            defaultValue={daten.NIKOTIN_SEIT}
                            hasError={props.hasError.NIKOTIN_SEIT}
                            errorMessage="Der Wert muß zwischen 0 und 100 liegen."
                            onChange={(e) => handleInteger(e, handleChange, 0, 100, props.hasError, props.setHasError)}
                            onBlur={e => handleIntegerBlur(e, 0, 100, props.hasError, props.setHasError)}
                            direction="row"
                            readOnly={props.readOnly}
                            outerEndComponent={<Button>Jahren.</Button>}
                        />
                    </Flex>
                </>
            }
            <p></p>
            {(daten.NIKOTIN === 3 || daten.NIKOTIN === 1) &&
                <Flex
                    direction="row"
                    gap={'1.5rem'}
                >
                    Möchten Sie mit dem Rauchen aufhören und dabei unterstützt werden?
                    <YesNo name="NIKOTIN_UNTERSTUETZNG" value={daten.NIKOTIN_UNTERSTUETZNG} onChange={handleChange} readOnly={props.readOnly} />
                </Flex>
            }
            <p></p>
            <h6>Alkohol:</h6>
            <Flex
                direction="row"
                gap={'2rem'}
            >
                <RadioGroupField
                    value={daten.ALKOHOL}
                    onChange={handleChange}
                    descriptiveText=""
                    name="ALKOHOL"
                    direction="row">
                    {['nie', 'gelegentlich', 'oft', 'täglich'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.ALKOHOL !== i ? props.readOnly : false}>{item}</Radio>)}
                </RadioGroupField>
            </Flex>
            {daten.ALKOHOL > 0 &&
                <>
                    <View style={{ marginLeft: '2rem' }}>
                        und zwar pro Woche im Durchschnitt:
                    </View>
                    <Flex direction="row" style={{ marginLeft: '2rem' }} alignItems='center'>
                        <CheckboxField
                            name="ALKOHOHL_BIER"
                            value={daten.ALKOHOHL_BIER === 1 ? "off" : "on"}
                            checked={daten.ALKOHOHL_BIER === 1}
                            onChange={handleCheck}
                            label="Bier&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
                            disabled={props.readOnly}
                        />
                        {daten.ALKOHOHL_BIER === 1 &&
                            <>
                                <TextField
                                    name="ALKOHOHL_BIER_ANZ"
                                    defaultValue={daten.ALKOHOHL_BIER_ANZ}
                                    width="10%"
                                    hasError={props.hasError.ALKOHOHL_BIER_ANZ}
                                    errorMessage="Der Wert muß zwischen 0 und 20 liegen."
                                    onChange={(e) => handleInteger(e, handleChange, 0, 20, props.hasError, props.setHasError)}
                                    onBlur={e => handleIntegerBlur(e, 0, 20, props.hasError, props.setHasError)}
                                    direction="row"
                                    readOnly={props.readOnly}
                                />
                                <RadioGroupField
                                    value={daten.ALKOHOL_BIER_TYP}
                                    onChange={handleChange}
                                    descriptiveText=""
                                    name="ALKOHOL_BIER_TYP"
                                    direction="row">
                                    {['Flaschen', 'Gläser'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.ALKOHOL_BIER_TYP !== i ? props.readOnly : false} >{item}</Radio>)}
                                </RadioGroupField>
                            </>
                        }
                    </Flex>
                    <p></p>
                    <Flex direction="row" style={{ marginLeft: '2rem' }} alignItems='center'>
                        <CheckboxField
                            name="ALKOHOHL_WEIN"
                            value={daten.ALKOHOHL_WEIN === 1 ? "off" : "on"}
                            checked={daten.ALKOHOHL_WEIN === 1}
                            onChange={handleCheck}
                            label="Wein&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
                            disabled={props.readOnly}
                        />
                        {daten.ALKOHOHL_WEIN === 1 &&
                            <>
                                <TextField
                                    name="ALKOHOHL_WEIN_ANZ"
                                    defaultValue={daten.ALKOHOHL_WEIN_ANZ}
                                    width="10%"
                                    hasError={props.hasError.ALKOHOHL_WEIN_ANZ}
                                    errorMessage="Der Wert muß zwischen 0 und 10 liegen."
                                    onChange={(e) => handleInteger(e, handleChange, 0, 10, props.hasError, props.setHasError)}
                                    onBlur={e => handleIntegerBlur(e, 0, 10, props.hasError, props.setHasError)}
                                    direction="row"
                                    readOnly={props.readOnly}
                                />
                                <RadioGroupField
                                    value={daten.ALKOHOHL_WEIN_TYP}
                                    onChange={handleChange}
                                    descriptiveText=""
                                    name="ALKOHOHL_WEIN_TYP"
                                    direction="row">
                                    {['Flaschen', 'Gläser'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.ALKOHOHL_WEIN_TYP !== i ? props.readOnly : false}>{item}</Radio>)}
                                </RadioGroupField>
                            </>
                        }
                    </Flex>
                    <p></p>
                    <Flex direction="row" style={{ marginLeft: '2rem' }} alignItems='center'>
                        <CheckboxField
                            name="ALKOHOHL_SCHNAPS"
                            value={daten.ALKOHOHL_SCHNAPS === 1 ? "off" : "on"}
                            checked={daten.ALKOHOHL_SCHNAPS === 1}
                            onChange={handleCheck}
                            label="Schnaps/Likör"
                            disabled={props.readOnly}
                        />
                        {daten.ALKOHOHL_SCHNAPS === 1 &&
                            <>
                                <TextField
                                    name="ALKOHOHL_SCHNAPS_ANZ"
                                    defaultValue={daten.ALKOHOHL_SCHNAPS_ANZ}
                                    width="10%"
                                    hasError={props.hasError.ALKOHOHL_SCHNAPS_ANZ}
                                    errorMessage="Der Wert muß zwischen 0 und 5 liegen."
                                    onChange={(e) => handleInteger(e, handleChange, 0, 5, props.hasError, props.setHasError)}
                                    onBlur={e => handleIntegerBlur(e, 0, 5, props.hasError, props.setHasError)}
                                    direction="row"
                                    readOnly={props.readOnly}
                                />
                                <RadioGroupField
                                    value={daten.ALKOHOHL_SCHNAPS_TYP}
                                    onChange={handleChange}
                                    descriptiveText=""
                                    name="ALKOHOHL_SCHNAPS_TYP"
                                    direction="row">
                                    {['Flaschen', 'Gläser'].map((item, i) => <Radio key={`RG_${i}`} value={i} disabled={daten.ALKOHOHL_SCHNAPS_TYP !== i ? props.readOnly : false}>{item}</Radio>)}
                                </RadioGroupField>
                            </>
                        }
                    </Flex>
                </>
            }
            <p></p>
            <Flex
                direction="row"
                gap={'1.5rem'}
                alignItems='center'
                style={{ marginLeft: '0.5rem' }}
            >
                <CheckboxField
                    name="MISSBRAUCH_AKTUELL"
                    value={daten.MISSBRAUCH_AKTUELL === 1 ? "off" : "on"}
                    checked={daten.MISSBRAUCH_AKTUELL === 1}
                    onChange={handleCheck}
                    label="Besteht"
                    disabled={props.readOnly}
                /> /
                <CheckboxField
                    name="MISSBRAUCH_WAR"
                    value={daten.MISSBRAUCH_WAR === 1 ? "off" : "on"}
                    checked={daten.MISSBRAUCH_WAR === 1}
                    onChange={handleCheck}
                    label="Bestand"
                    disabled={props.readOnly}
                />
            </Flex>
            <Text style={{ marginLeft: '0.5rem' }}><b>Abhängigkeit/Missbrauch</b> von Betäubungsmitteln, Drogen, Medikamenten oder anderen Substanzen?</Text>
            {(daten.MISSBRAUCH_AKTUELL === 1 || daten.MISSBRAUCH_WAR === 1) &&
                <TextField
                    label={<Text style={{ marginLeft: '0.5rem' }}><i>Welche?</i></Text>}
                    name="MISSBRAUCH"
                    defaultValue={daten.MISSBRAUCH}
                    width="100%"
                    onChange={handleChange}
                    maxLength={256}
                    readOnly={props.readOnly}
                    style={{ marginLeft: '0.5rem' }}
                />
            }
        </>
    )
}

export default VegetativeAnamnese;
